import React, { useEffect } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Grid, Stack, Typography, useTheme } from '@mui/material';
import { StyledPaperItem } from '../common/mui-components';
import { Room } from '../components/room';
import { Profile } from '@par/shared/types/player';
import { CustomQuestionTestingData } from '../components/custom-questions';

type PropTypes = {
  close: () => void;
  customQuestionTestingData: CustomQuestionTestingData;
  open: boolean;
  profile: Profile;
};

export const CustomQuestionPreviewDialog = ({
  close,
  customQuestionTestingData,
  open,
  profile,
}: PropTypes) => {
  const theme = useTheme();

  useEffect(() => {
    console.log('customQuestionTestingData', customQuestionTestingData);
  }, [customQuestionTestingData]);

  return (
    <Dialog open={open} onClose={close} fullScreen>
      <DialogTitle>
        <Typography variant="h5" textAlign={'center'}>
          Previewing Custom Question
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ width: '100%', height: '100%' }}>
        <Room
          customQuestionTestingData={customQuestionTestingData}
          profile={profile}
          onUpdateProfile={() => {}}
          showSnackbarMessage={() => {}}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={close} fullWidth>
          CLOSE
        </Button>
      </DialogActions>
    </Dialog>
  );
};
